<div class="sgt-representante-produtividade-geral-kpi-table">
    <table class="table table-striped table-hover table-bordered" [id]="idDataTable">
        <thead>
            <tr>
                <th class="col-representante col-codigo-representante" rowspan="3">
                    Código
                </th>
                <th class="col-representante col-nome-representante" rowspan="3">
                    Nome
                </th>   
                <th class="col-representante col-situacao-representante text-center" rowspan="3">
                    Situação
                </th> 
                <th class="col-representante col-modalidade-comercial-representante text-center" rowspan="3">
                    Modalidade Comercial
                </th>                                             
            </tr>
            <ng-template [ngIf]="data?.anos">
                <!-- Anos -->
                <tr class="row-periodo">
                    <ng-template ngFor let-produtividadeAnual [ngForOf]="data?.anos">
                        <!-- Semestres -->
                        <ng-template ngFor let-produtividadeSemestral [ngForOf]="produtividadeAnual.semestres">
                            <!-- Trimestres -->
                            <ng-template ngFor let-produtividadeTrimestral [ngForOf]="produtividadeSemestral.trimestres">
                                <!-- Meses -->
                                <ng-template ngFor let-produtividadeMensal let-odd="odd" [ngForOf]="produtividadeTrimestral.meses">
                                    <th class="col-produtividade-mensal text-center" [class.odd]="odd" colspan="3">
                                        {{produtividadeMensal.mes | mesAbreviacao}}/{{produtividadeAnual.ano | anoAbreviacao}}
                                    </th>         
                                </ng-template>
        
                                <th class="col-produtividade-trimestral text-center" colspan="3" *ngIf="state?.isShowTrimestral">
                                    {{produtividadeTrimestral.trimestre | trimestreAbreviacao}}/{{produtividadeAnual.ano | anoAbreviacao}}                                   
                                </th>                        
                            </ng-template>
        
                            <th class="col-produtividade-semestral text-center" colspan="3" *ngIf="state?.isShowSemestral">
                                {{produtividadeSemestral.semestre | semestreAbreviacao}}/{{produtividadeAnual.ano | anoAbreviacao}}
                            </th>                     
                        </ng-template>
        
                        <th class="col-produtividade-anual text-center" colspan="3" *ngIf="state?.isShowAnual">
                            {{produtividadeAnual.ano}}
                        </th>                
                    </ng-template>
                </tr>

                <!-- Anos -->
                <tr class="row-titles">
                    <ng-template ngFor let-produtividadeAnual [ngForOf]="data?.anos">
                        <!-- Semestres -->
                        <ng-template ngFor let-produtividadeSemestral [ngForOf]="produtividadeAnual.semestres">
                            <!-- Trimestres -->
                            <ng-template ngFor let-produtividadeTrimestral [ngForOf]="produtividadeSemestral.trimestres">
                                <!-- Meses -->
                                <ng-template ngFor let-produtividadeMensal let-odd="odd" [ngForOf]="produtividadeTrimestral.meses">
                                    <th class="col-produtividade-mensal col-aquisicao text-right" [class.odd]="odd" title="Aquisição de Clientes">
                                        Aquisição
                                    </th>
                                    <th class="col-produtividade-mensal col-carteira-inativa text-right" [class.odd]="odd" title="Carteira Inativa">
                                        Carteira Inativa
                                    </th>
                                    <th class="col-produtividade-mensal col-comissao text-right" [class.odd]="odd" title="Comissão Média">
                                        Comissão Média
                                    </th>                                                                                      
                                </ng-template>
        
                                <ng-template [ngIf]="state?.isShowTrimestral">
                                    <th class="col-produtividade-trimestral col-aquisicao text-right" title="Aquisição de Clientes">
                                        Aquisição
                                    </th>
                                    <th class="col-produtividade-trimestral col-carteira-inativa text-right" title="Carteira Inativa">
                                        Carteira Inativa
                                    </th>
                                    <th class="col-produtividade-trimestral col-comissao text-right" title="Comissão Média">
                                        Comissão Média
                                    </th>                                      
                                </ng-template>                                                                           
                            </ng-template>
        
                            <ng-template [ngIf]="state?.isShowSemestral">
                                <th class="col-produtividade-semestral col-aquisicao text-right" title="Aquisição de Clientes">
                                    Aquisição
                                </th>
                                <th class="col-produtividade-semestral col-carteira-inativa text-right" title="Carteira Inativa">
                                    Carteira Inativa
                                </th>
                                <th class="col-produtividade-semestral col-comissao text-right" title="Comissão Média">
                                    Comissão Média
                                </th>                                 
                            </ng-template>
                        </ng-template>
        
                        <ng-template [ngIf]="state?.isShowAnual">
                            <th class="col-produtividade-anual col-aquisicao text-right" title="Aquisição de Clientes">
                                Aquisição
                            </th>
                            <th class="col-produtividade-anual col-carteira-inativa text-right" title="Carteira Inativa">
                                Carteira Inativa
                            </th>
                            <th class="col-produtividade-anual col-comissao text-right" title="Comissão Média">
                                Comissão Média
                            </th>                             
                        </ng-template>                      
                    </ng-template>
                </tr>                
            </ng-template>            
        </thead>
        <tbody>
            <tr *ngFor="let representante of data?.representantes; let index = index">
                <td class="col-representante col-codigo-representante">
                    {{representante.codigoIntegracaoErp}}
                </td>
                <td class="col-representante col-nome-representante" title="{{representante.nome | representanteNome: representante.nomeFantasia}}">
                    <span class="col-nome-representante-group">
                        <span class="col-nome-representante-item">
                            {{representante.nome | representanteNome: representante.nomeFantasia}}
                        </span>
                        <small class="col-nome-representante-item">
                            {{representante.nome | representanteNomeSecundario: representante.nomeFantasia}}
                        </small>
                    </span>
                </td>    
                <td class="col-representante col-situacao-representante text-center">
                    <span class="{{representante.situacao | representanteSituacaoBadge}}" title="{{representante.situacao | representanteSituacao}}">
                        {{representante.situacao | representanteSituacao}}
                    </span>
                </td>
                <td class="col-representante col-modalidade-comercial-representante text-center">
                    <sgt-representante-modalidade-comercial-badge
                        [modalidade]="representante.modalidadeComercial">
                    </sgt-representante-modalidade-comercial-badge>
                </td>                
    
                <!-- Anos -->
                <ng-template ngFor let-produtividadeAnual [ngForOf]="representante.anos">
                    <!-- Semestres -->
                    <ng-template ngFor let-produtividadeSemestral [ngForOf]="produtividadeAnual.semestres">
                        <!-- Trimestres -->
                        <ng-template ngFor let-produtividadeTrimestral [ngForOf]="produtividadeSemestral.trimestres">
                            <!-- Meses -->
                            <ng-template ngFor let-produtividadeMensal let-odd="odd" [ngForOf]="produtividadeTrimestral.meses">                                
                                <td class="col-produtividade-mensal col-aquisicao text-right" [class.odd]="odd" title="Aquisição de Clientes: {{produtividadeMensal.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}">
                                    {{produtividadeMensal.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-produtividade-mensal col-carteira-inativa text-right" [class.odd]="odd" title="Carteira Inativa: {{produtividadeMensal.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}">
                                    {{produtividadeMensal.carteiraInativa?.quantidadeClientesInativos| decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-produtividade-mensal col-comissao text-right" [class.odd]="odd" title="Comissão Média: {{produtividadeMensal.comissao?.percComissao | decimalFormat: 1:2:2}}%">
                                    {{produtividadeMensal.comissao?.percComissao| decimalFormat: 1:2:2}}%
                                </td>                                                                                          
                            </ng-template>
    
                            <ng-template [ngIf]="state?.isShowTrimestral">
                                <td class="col-produtividade-trimestral col-aquisicao text-right" title="Aquisição de Clientes: {{produtividadeTrimestral.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}">
                                    {{produtividadeTrimestral.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-produtividade-trimestral col-carteira-inativa text-right" title="Carteira Inativa: {{produtividadeTrimestral.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}">
                                    {{produtividadeTrimestral.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-produtividade-trimestral col-comissao text-right" title="Comissão Média: {{produtividadeTrimestral.comissao?.percComissao | decimalFormat: 1:2:2}}%">
                                    {{produtividadeTrimestral.comissao?.percComissao| decimalFormat: 1:2:2}}%
                                </td>                                  
                            </ng-template>                                                                    
                        </ng-template>
    
                        <ng-template [ngIf]="state?.isShowSemestral">
                            <td class="col-produtividade-semestral col-aquisicao text-right" title="Aquisição de Clientes: {{produtividadeSemestral.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}">
                                {{produtividadeSemestral.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}
                            </td>
                            <td class="col-produtividade-semestral col-carteira-inativa text-right" title="Carteira Inativa: {{produtividadeSemestral.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}">
                                {{produtividadeSemestral.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}
                            </td>  
                            <td class="col-produtividade-semestral col-comissao text-right" title="Comissão Média: {{produtividadeSemestral.comissao?.percComissao | decimalFormat: 1:2:2}}%">
                                {{produtividadeSemestral.comissao?.percComissao| decimalFormat: 1:2:2}}%
                            </td>                            
                        </ng-template>                                              
                    </ng-template>

                    <ng-template [ngIf]="state?.isShowAnual">
                        <td class="col-produtividade-anual col-aquisicao text-right" title="Aquisição de Clientes: {{produtividadeAnual.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}">
                            {{produtividadeAnual.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}
                        </td>
                        <td class="col-produtividade-anual col-carteira-inativa text-right" title="Carteira Inativa: {{produtividadeAnual.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}">
                            {{produtividadeAnual.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}
                        </td>
                        <td class="col-produtividade-anual col-comissao text-right" title="Comissão Média: {{produtividadeAnual.comissao?.percComissao | decimalFormat: 1:2:2}}%">
                            {{produtividadeAnual.comissao?.percComissao| decimalFormat: 1:2:2}}%
                        </td>                        
                    </ng-template>                                 
                </ng-template>
            </tr>            
        </tbody>
        <tfoot>
            <tr>
                <td class="col-representante col-codigo-representante" colspan="2">
                    {{data?.representantes?.length | decimalFormat: 1:0:0}} representante(s)
                </td>

                <td class="col-representante col-situacao-representante"></td>
                <td class="col-representante col-modalidade-comercial-representante"></td>

                <!-- Anos -->
                <ng-template ngFor let-produtividadeAnual [ngForOf]="data?.anos">
                    <!-- Semestres -->
                    <ng-template ngFor let-produtividadeSemestral [ngForOf]="produtividadeAnual.semestres">
                        <!-- Trimestres -->
                        <ng-template ngFor let-produtividadeTrimestral [ngForOf]="produtividadeSemestral.trimestres">
                            <!-- Meses -->
                            <ng-template ngFor let-produtividadeMensal let-odd="odd" [ngForOf]="produtividadeTrimestral.meses">
                                <td class="col-produtividade-mensal col-aquisicao text-right" [class.odd]="odd" title="Aquisição de Clientes: {{produtividadeMensal.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}">
                                    {{produtividadeMensal.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-produtividade-mensal col-carteira-inativa text-right" [class.odd]="odd" title="Carteira Inativa: {{produtividadeMensal.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}">
                                    {{produtividadeMensal.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-produtividade-mensal col-comissao text-right" [class.odd]="odd" title="Comissão Média: {{produtividadeMensal.comissao?.percComissao | decimalFormat: 1:2:2}}%">
                                    {{produtividadeMensal.comissao?.percComissao | decimalFormat: 1:2:2}}%
                                </td>                                                                                               
                            </ng-template>

                            <ng-template [ngIf]="state?.isShowTrimestral">
                                <td class="col-produtividade-trimestral col-aquisicao text-right" title="Aquisição de Clientes: {{produtividadeTrimestral.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}">
                                    {{produtividadeTrimestral.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}
                                </td>
                                <td class="col-produtividade-trimestral col-carteira-inativa text-right" title="Carteira Inativa: {{produtividadeTrimestral.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}">
                                    {{produtividadeTrimestral.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}
                                </td> 
                                <td class="col-produtividade-trimestral col-comissao text-right" title="Comissão Média: {{produtividadeTrimestral.comissao?.percComissao | decimalFormat: 1:2:2}}%">
                                    {{produtividadeTrimestral.comissao?.percComissao | decimalFormat: 1:2:2}}%
                                </td>                                 
                            </ng-template>                                                    
                        </ng-template>

                        <ng-template [ngIf]="state?.isShowSemestral">
                            <td class="col-produtividade-semestral col-aquisicao text-right" title="Aquisição de Clientes: {{produtividadeSemestral.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}">
                                {{produtividadeSemestral.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}
                            </td>
                            <td class="col-produtividade-semestral col-carteira-inativa text-right" title="Carteira Inativa: {{produtividadeSemestral.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}">
                                {{produtividadeSemestral.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}
                            </td> 
                            <td class="col-produtividade-semestral col-comissao text-right" title="Comissão Média: {{produtividadeSemestral.comissao?.percComissao | decimalFormat: 1:2:2}}%">
                                {{produtividadeSemestral.comissao?.percComissao | decimalFormat: 1:2:2}}%
                            </td>                            
                        </ng-template>                                            
                    </ng-template>

                    <ng-template [ngIf]="state?.isShowAnual">
                        <td class="col-produtividade-anual col-aquisicao text-right" title="Aquisição de Clientes: {{produtividadeAnual.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}">
                            {{produtividadeAnual.aquisicao?.quantidadeClientesAquisicao | decimalFormat: 1:0:0}}
                        </td>
                        <td class="col-produtividade-anual col-carteira-inativa text-right" title="Carteira Inativa: {{produtividadeAnual.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}">
                            {{produtividadeAnual.carteiraInativa?.quantidadeClientesInativos | decimalFormat: 1:0:0}}
                        </td> 
                        <td class="col-produtividade-anual col-comissao text-right" title="Comissão Média: {{produtividadeAnual.comissao?.percComissao | decimalFormat: 1:2:2}}%">
                            {{produtividadeAnual.comissao?.percComissao | decimalFormat: 1:2:2}}%
                        </td>                        
                    </ng-template>                                         
                </ng-template>
            </tr>            
        </tfoot>         
    </table>
</div>